export default __webpack_public_path__ + "static/N0266-6b322116f9f2224904772d89ce3d848a.png";